﻿
export class RegistrationFormComponent {

    // on name field leave check input

    // on email field leave check input

    // on form submit take the form fields, compose api request and send them through the communicator

} 